// extracted by mini-css-extract-plugin
export default {"container":"playground-page_container__126Sk","canvas":"playground-page_canvas__2bKED","form":"playground-page_form__21fPq"};